import { render, staticRenderFns } from "./AppliedPmtaConfig.vue?vue&type=template&id=1f10de51&scoped=true"
import script from "./AppliedPmtaConfig.vue?vue&type=script&lang=js"
export * from "./AppliedPmtaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10de51",
  null
  
)

export default component.exports